import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ErrorHandlerService } from '../../../services/error-handler/error-handler.base-service';
import { permissionsConverter } from '../../../services/account/permissions/permissions.converter';
import { PermissionsFacade } from '../../../services/account/permissions/permissions.facade';
import * as fromActions from './permissions.actions';

@Injectable()
export class PermissionsEffects {
  loadPermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.LoadPermissions),
      switchMap(() =>
        this.permissionsFacade.getPermissions().pipe(
          map(permissionsConverter.fromDto),
          map(response => fromActions.LoadPermissionsSuccess({ response })),
          catchError(error => {
            this.errorHandlerService.handleError(
              '(REQUEST ERROR) on permissions.effects.ts:',
              error
            );
            return [fromActions.LoadPermissionsFailed(error)];
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private permissionsFacade: PermissionsFacade,
    private errorHandlerService: ErrorHandlerService
  ) {}
}
